import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import SimpleReactValidator from 'simple-react-validator';
import { setUser } from '../../redux/actions/user.actions';
import logo from '../../assets/images/Lovrican-Logo-Icon.svg';
import btnIcon from '../../assets/images/arrow-circle.svg';
import { authCall } from '../../services';

const Step9Component = ({ userDetails, handleNext, step }) => {
  const dispatch = useDispatch();
  const [validator] = useState(new SimpleReactValidator());
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    aboutMe: userDetails?.about ? userDetails?.about : ''
  });

  const submitForm = async () => {
    if (validator.allValid()) {
      const formData = {
        aboutMe: values.aboutMe
      };
      setLoading(true);
      const resp = await authCall('auth/register-section', formData);
      if (resp && resp.success === true) {
        dispatch(setUser(resp.data.user));
        handleNext(step);
        setLoading(false);
      }
      setLoading(false);
    } else {
      validator.showMessages();
      setValues({ ...values });
    }
  };

  return (
    <>
        <section className="registerDetails section-one lattest-reg-screen">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              <div className="logo cursor-pointer" role="button" tabIndex="0">
                <img src={logo} className="img-fluid" alt="Lovrican Logo" />
              </div>
            </div>
            <div className="col-12 text-center">
              <div className="progress">
                <div className="progress-bar step9" />
              </div>
            </div>
          </div>

          <div className="row join-reg top-join">
          <div className="col-md-12 col-lg-12">
              <div className='subtitle'>Introduce yourself authentically. You are awesome,
              let your uniqueness shine through naturally</div>
            </div>
            </div>
            <div className="row join-reg bottom-join inner_bottom" >
              <div className="col-md-12 col-lg-12 pb-4 custome_select large_height_textarea mb-3">
                <textarea
                  type="text"
                  name="aboutMe"
                  placeholder="About Me"
                  className="custom_input resize-none"
                  autoComplete="off"
                  value={values.aboutMe}
                  onChange={(e) =>
                    setValues({ ...values, aboutMe: e.target.value })
                  }
                />
                {validator.message(
                  'aboutMe',
                  values.aboutMe,
                  'required|min:50|max:300'
                )}
              </div>

              <div className="col-md-12 col-lg-12 pb-4 mb-3 mt-3 marb7 text-right">
                <button
                  className={`new_next_btn ${loading ? 'hks-btn-disable' : ''}`}
                  onClick={submitForm}
                  onKeyDown={(event) => event.key === 'Enter' && submitForm()}
                  type="button"
                  tabIndex="0"
                  disabled={loading || false}
                >
                 <img src={btnIcon} className="img-fluid" alt="Lovrican Logo" />
                </button>
              </div>
            </div>
        </div>
      </section>
    </>
  );
};

export default Step9Component;
